/* eslint-disable angular/ng_angularelement */

import modalConfirmation from '../../shared/components/modal-response/modal-response.view.html';
import modalConfirmationCart from '../modal-confirmation/modal-confirmation.view.html';
import modalRecommendProduct from '../../shared/components/modal-recommend-product/modal-recommend-product.view.html';
import modalCommentsController from '../modal-comments/modal-comments.view.html';
import modalVideo from '../../shared/components/modal-video/modal-video.view.html';
import angular from "angular";

let inject = [
  '$scope',
  'CategoryService',
  '$state',
  '$rootScope',
  'SharedService',
  '$stateParams',
  '$uibModal',
  'ProcedureDetailService',
  'CatalogService',
  '$timeout',
  'CartService',
  '$mdToast',
  'SessionService',
  'ByFavoritesService'
];

class ProcedureDetailController {
  constructor($scope,
              CategoryService,
              $state,
              $rootScope,
              SharedService,
              $stateParams,
              $uibModal,
              ProcedureDetailService,
              CatalogService,
              $timeout,
              CartService,
              $mdToast,
              SessionService,
              ByFavoritesService) {

    this.$state = $state;
    this.$scope = $scope;
    this.ProcedureDetailService = ProcedureDetailService;
    this.$rootScope = $rootScope;
    this.$stateParams = $stateParams;
    this.$uibModal = $uibModal;
    this.SharedService = SharedService;
    this.$timeout = $timeout;
    this.$mdToast = $mdToast;
    this.CatalogService = CatalogService;
    this.loanding = false;
    this.showProcedurePrice = true;
    this.ByFavoritesService = ByFavoritesService;
    this.procedureId = this.$stateParams.procedureId || '';
    this.procedureSlug = this.$stateParams.procedureSlug || '';
    this.property = 'date';
    this.productQuantity = 1;
    this.reverse = false;
    this.features = [];
    this.CartService = CartService;
    this.SessionService = SessionService

    this.pageName = "PAG-23";
    this.SharedService.getCMSBanners(this.pageName).then(response => {
      this.cmsData = response;
      this.shCtrl.setTags(this.cmsData.seo);
    });


    this.dataCart = {};
    this.dataProducs = {};

    this.productItems = {};
    this.showComments = false;
  }

  $onInit() {
    this.getProcedureDetail();
  }


  getFeatures(itemId) {
    this.ProcedureDetailService.getProcedureFeatures(itemId).then(value => {
      this.features = value;

      this.$timeout(() => {
        const items = document.querySelectorAll(".accordion-link");

        function toggleAccordion() {
          this.classList.toggle('active');
          this.nextElementSibling.classList.toggle('active');
        }

        items.forEach(item => item.addEventListener('click', toggleAccordion));
      }, 500);
    });
  }

  getProcedureDetail() {
    this.loadingProcedureDetail = true;
    let userId = '';
    try {
      userId = this.shCtrl.globals.currentUser.userId;
    } catch (e) {
    }
    this.ProcedureDetailService.getProcedureDetail(this.procedureId, this.procedureSlug, userId).then(response => {
      this.loadingProcedureDetail = false;
      try {

                if (response != 'false'){
                  this.procedureDetail = response;
                  if (this.procedureDetail.canonical){
                    var meta = document.createElement('link');
                    meta.setAttribute('rel', 'canonical');
                    meta.setAttribute('href', __env.frontPath + 'procedure-detail-slug/'+this.procedureDetail.canonical);
                    document.head.appendChild(meta);
                  }
                  this.procedureDetail.seo["url_imagen"]=this.procedureDetail.imagesDetail[0].path + this.procedureDetail.imagesDetail[0].image;
                  this.procedureDetail.seo["slug"]= __env.frontPath +"procedure-detail-slug/" + this.procedureDetail.slug;
                  this.shCtrl.setTags(this.procedureDetail.seo);
                  //console.log("aqui viene pap");
                  this.jsonproducts = angular.toJson({
                    "@context": "https://schema.org/",
                    "@type": "Product",
                    "name": this.procedureDetail.name,
                    "image": [
                      this.procedureDetail.imagesDetail[0].path + this.procedureDetail.imagesDetail[0].image,
                    ],
                    "description": this.procedureDetail.description_strip,
                    "sku": this.procedureDetail.reference,
                    "aggregateRating": {
                      "@type": "AggregateRating",
                      "ratingValue": this.procedureDetail.globalRating,
                      "reviewCount": this.procedureDetail.reviewCount
                    },
                    "offers": {
                      "@type": "Offer",
                      "priceCurrency": this.procedureDetail.rate,
                      "price": this.procedureDetail.itemPrice,
                      "category":this.procedureDetail.category.title,
                      "sku":this.procedureDetail.reference,
                    }
                  });
                  //console.log("paso");
                  var jsonLd = angular.element(document.getElementById('json-ld-page'))[0];
                  jsonLd.innerHTML = this.jsonproducts;

          this.getFeatures(response.id);
          this.getProductComments();
          /*this.procedureoPlantilla = response;
          this.initPluginsProcedureDetails();
          this.getProcedureComments();*/

          if (this.procedureDetail.clonedAttributesDetail.length > 0) {
            this.showProcedurePrice = false;
          }

          if (this.procedureDetail.isTemplate) {
            this.procedureTemplateCopy = angular.copy(this.procedureDetail);
          }
        } else {
          this.$state.go('home.productSearch', {searchText: this.procedureSlug});
        }

      }
      catch (e) {

        this.$state.go('/404');
      }
    }).catch(reason => {

      this.$state.go('/404');
    });
  }

  increaseProductQuantity() {
    this.productQuantity++;
  }

  openVideo(video) {
    let options = {
      video: video,
      propertySrc: 'url'
    };

    this.$uibModal.open({
      animation: true,
      template: modalVideo,
      controller: 'ModalVideoController',
      controllerAs: 'mdCtrl',
      size: '',
      resolve: {
        modalOptions: () => options
      }
    });
  }

  decreaseProductQuantity() {
    if (this.productQuantity > 1)
      this.productQuantity--;
  }

  recommendProcedure() {
    this.$uibModal.open({
      animation: true,
      template: modalRecommendProduct,
      controller: 'ModalRecommendProductController',
      controllerAs: 'mdCtrl',
      size: '',
      resolve: {
        product: () => this.procedureDetail
      }
    });
  }

  clonedAttributesSelected() {
    this.formInvalid = false;
    this.clonedAttributesSelectedLength = 0;
    let vm = this;


    this.clonedProcedurePrice = '';
    this.showProcedurePrice = false;
    this.showBottomAddCart = true;
    this.messageClonedProcedurePrice = '';

    angular.forEach(this.clonedFormData, function (value, key) {
      value = value || '';
      if (value) {
        vm.clonedAttributesSelectedLength++;
      }
    });

    if (this.procedureDetail.clonedAttributesDetail.length === this.clonedAttributesSelectedLength) {
      let userId = '';
      try {
        userId = this.shCtrl.globals.currentUser.userId;
      }
      catch (e) {
      }
      this.loadingClonedProcedurePrice = true;
      let data = {
        'productTemplateId': this.procedureTemplateCopy.id,
        'attributes': this.clonedFormData,
        'userId': userId
      };
      this.loadingClonedProcedurePrice = true;
      this.showBottomAddCart = false;

      this.ProcedureDetailService.clonedProcedurePrice(data).then(response => {
        this.loadingClonedProcedurePrice = false;
        this.showBottomAddCart = true;

        if (!response.error) {
          this.showProcedurePrice = true;
          this.procedureDetail.currentPrice = response.data.currentPrice;
          this.procedureDetail.discountValue = response.data.discountValue;
          this.procedureDetail.discountPercentage = response.data.discountPercentage;

          this.procedureDetail.clonedId = response.data.clonedId;

          this.procedureDetail.quote = response.data.quote;
          this.procedureDetail.textLabel = response.data.textLabel;
          this.procedureDetail.textLabelContinue = response.data.textLabelContinue;
          this.procedureDetail.textAction = response.data.textAction;

          // Replace the template item for the real item
          this.procedureDetail = response.data.dataItem;
          this.procedureDetail.clonedAttributesDetail = this.procedureTemplateCopy.clonedAttributesDetail;
          this.loadedItemFromTemplate = true;
          // Restart pretty photo
        }
        else {
          this.messageClonedProcedurePrice = 'Procedimiento no disponible';
          this.procedureDetail = angular.copy(this.productTemplateCopy);
          this.loadedItemFromTemplate = false;

        }
      }).catch(reason => {
        console.log('response - error');
        console.log(reason);
        this.loadingClonedProcedurePrice = false;
        alert('Error al obtener el precio del procedimiento');
      });

    }
    else {
      // Recover the template
      this.procedureDetail = angular.copy(this.procedureTemplateCopy);
      this.loadedItemFromTemplate = false;

      this.procedureDetail.discountValue = 0;
      this.procedureDetail.discountPercentage = 0;

    }
    return false;
  }

  updateFavoriteProducts(product) {

    product.isSettingAsFavorite = true;
    let userId = '';
    try {
      userId = this.shCtrl.globals.currentUser.userId;
    }
    catch (e) {
    }
    if (userId) {

      let data = {
        'productId': product.id,
        'userId': userId,
        'setFavorite': !product.isFavorite
      };
      this.CatalogService.updateFavoriteProducts(data).then(response => {
        product.isFavorite = !product.isFavorite;
        product.isSettingAsFavorite = false;

        if (!response.error) {
          this.ByFavoritesService.getResumeProductsFavorites(this.shCtrl.globals.currentUser.userId).then(favoritesResponse => {
            this.shCtrl.globals.currentUser.favoriteItems = favoritesResponse;
            this.SessionService.put('globals', this.shCtrl.globals);

          });
        }

      }).catch(error => {
        product.isSettingAsFavorite = false;
        if (__env.adaptative) {
          this.messageMaterial('Ha ocurrido un error al actualizar el procedimiento');
        } else {
          let options = {
            title: '',
            isHtml: false,
            content: 'Ha ocurrido un error al actualizar el procedimiento',
            size: '',
            showBottonCancel: false,
            textActionCancel: '',
            textAction: 'Aceptar'
          };

          this.messageResponse(options);
        }
      });
    }
  }

  openCommentsModal() {

    let userId = '';
    try {
      userId = this.shCtrl.globals.currentUser.userId;
    } catch (e) {
    }

    let modalInstance = this.$uibModal.open({
      animation: true,
      template: modalCommentsController,
      controller: 'ModalCommentsController',
      controllerAs: 'mdCtrl',
      size: '',
      resolve: {
        product: () => this.procedureDetail,
        userId: () => userId
      }
    });
    modalInstance.result.then(result => {

      let options = {
        title: '',
        isHtml: true,
        content: result.message,
        size: '',
        showBottonCancel: false,
        textActionCancel: '',
        textAction: 'Aceptar'
      };
      this.messageResponse(options);

    }).catch(error => {
      console.log(error);
    });
  }

  getProductComments() {

    if (this.loadingComments) return;

    let userId = '';
    try {
      userId = this.shCtrl.globals.currentUser.userId;
    } catch (e) {
    }

    this.loadingComments = true;
    this.pageNumber++;

    this.ProcedureDetailService.getProductComments(this.procedureDetail.id, userId).then(val => {

      if (!val.error) {

        this.globalRating = val.globalRating;
        this.globalRatingDecimal = val.globalRatingDecimal;
        this.comments = [];
        val.data.forEach(value => {
          this.comments.push({
            rate: value.puntaje,
            title: value.titulo,
            description: value.comentario,
            user: value.usuario_nombre,
            date: value.fecha
          });
        });
      }

      if (val.data.length > 0) {
        this.loadingComments = false;
      } else {
        this.finishComments = true;
      }

    }).catch(err => {
      console.log(err);
    });
  }

  addItemToCart(product, quantity) {
    if (this.procedureDetail.showClonedAction) {
      this.formInvalid = true;
    } else {
      if (product.id && quantity) {
        let userId = '', cart = null;
        try {
          userId = this.shCtrl.globals.currentUser.userId;
        } catch (e) {
        }
        try {
          cart = this.shCtrl.cart;
        } catch (e) {
        }
        this.CartService.addItemToCart(product, quantity, null, null, userId, cart).then(response => {
          if (!response.error) {
            // this.$scope.$emit('onUpdateCart');
            // let modalInstance2 = this.$uibModal.open({
            //     animation: true,
            //     template: modalConfirmationCart,
            //     controller: 'ModalConfirmationController',
            //     controllerAs: 'mdCtrl',
            //     size: 'lg',
            //     resolve: {
            //         product: () => product
            //     }
            // });
            // modalInstance2.result.then(response => {

            // }).catch(reason => {
            //     try {
            //         this.$state.go('home.procedureListSlug', {procedureSlug: product.category.slug});
            //     } catch (e) {

            //     }
            // });

            this.dataCart = {};
            this.dataProducs = {};

            this.modalConfirmation(product, quantity);

          } else {
            let options = {
              title: '',
              isHtml: true,
              content: response.message,
              size: '',
              showBottonCancel: false,
              textActionCancel: '',
              textAction: 'Aceptar'
            };
            this.messageResponse(options);
          }
        }).catch(reason => {
          let options = {
            title: '',
            isHtml: false,
            content: reason,
            size: '',
            showBottonCancel: false,
            textActionCancel: '',
            textAction: 'Aceptar'
          };
          this.messageResponse(options);
        });
      }
    }

  }

  messageResponse(options, callAcept, callback, callCancel, callbackCancel) {
    let modalInstance = this.$uibModal.open({
      animation: true,
      template: modalConfirmation,
      controller: 'ModalResponseController',
      controllerAs: 'mdCtrl',
      size: options.size,
      resolve: {
        modalOptions: () => options
      }
    });
    modalInstance.result.then(() => {
      if (callAcept) {
        callback();
      }
    }).catch(reason => {
      if (callCancel) {
        callbackCancel();
      }
    });
  }

  messageMaterial(text) {
    var mdToast = this.$mdToast;
    this.$mdToast.show({
      hideDelay: 7000,
      controller: function () {
        this.closeToast = function () {
          mdToast.hide();
        }

      },
      controllerAs: 'toast',
      template: '<md-toast>\n' +
      '  <span class="md-toast-text">' + text + '</span>\n' +
      '  <md-button ng-click="toast.closeToast()">\n' +
      '    Cerrar\n' +
      '  </md-button>\n' +
      '</md-toast>'
    });
  }


  modalConfirmation(products, quantity) {
    if (__env.adaptative) {
      this.messageMaterial(products.name + ' Ha sido agregado correctamente')
    } else {
      this.productAdded = products;
      this.productAdded.image = products.imagesDetail[0].path + products.imagesDetail[0].image;
      this.productAdded.price = products.itemPrice;
      this.productAdded.discount = products.discountValue;
      this.productAdded.ivaValue = products.taxValue;
      this.productAdded.quantity = quantity;
      this.productAdded.total = (products.itemPrice - products.discountValue + products.taxValue) * quantity;
      $('#myModal').modal('toggle');
    }
    this.productAdded = angular.copy(products);
    this.SessionService.getGlobals().then(response => {

      let cartId = this.SessionService.get('cartId') || '';
      let userId = '';
      try {
        userId = response.currentUser.userId;
      }
      catch (e) {
      }
      let clientPriceListName = '';
      try {
        clientPriceListName = this.SessionService.get('quoteCartSeller').clientPriceList;
      } catch (e) {
      }

      this.CartService.getCart(cartId, userId, clientPriceListName).then(response2 => {
        this.dataCart = response2;
        this.dataProducs = this.dataCart.items.filter(val => val.id === this.productAdded.id)[0];

        this.$scope.$emit('onUpdateCart', 'modalResponseItems');


      })
    }).catch(reason => {
      return null;
    });
  }

}

ProcedureDetailController.$inject = inject;

export default ProcedureDetailController;




/** WEBPACK FOOTER **
 ** C:/Users/dares/Documents/SIESA_repositorios/himalaya/www/components/catalog/procedure-detail/procedure-detail.controller.js
 **/